import { Injectable, NgZone, OnDestroy } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	Router,
	RouterStateSnapshot,
	UrlTree,
} from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService, isLoggedIn, UserSession } from './auth.service';

@Injectable({
	providedIn: 'root',
})
export class NavigationAuthGuardService implements OnDestroy {
	private loggedInSubscription?: Subscription;

	constructor(
		private readonly zone: NgZone,
		private readonly router: Router,
		private readonly authService: AuthService
	) {
		this.loggedInSubscription = this.authService
			.userSession()
			.pipe(map((userSession: UserSession) => isLoggedIn(userSession)))
			.subscribe((loggedIn) => {
				if (!loggedIn) {
					this.zone
						.run(() =>
							this.router.navigateByUrl('/login', {
								state: { message: loggedIn },
							})
						)
						.then(() => {});
				}
			});
	}

	ngOnDestroy(): void {
		this?.loggedInSubscription?.unsubscribe();
	}

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<true | UrlTree> {
		return this.authService.userSession().pipe(
			map((userSession) => {
				if (!userSession.token) {
					return this.router.parseUrl('/login');
				}

				const mfaRequired = !!userSession.claims?.mfaRequired;
				if (mfaRequired) {
					return this.router.parseUrl('/do-mfa');
				}

				const activeEntityRelationshipId =
					userSession.claims?.activeEntityRelationshipId ?? '';
				if (activeEntityRelationshipId === '') {
					return this.router.parseUrl('/select-active-role');
				}

				return true;
			})
		);
	}
}
